import handshakePleinBleu from '../../../assets/handshake-plein-bleu.svg'
import cartonFragilePleinBleu from '../../../assets/carton-fragile-plein-bleu.svg'
import labelPleinBleu from '../../../assets/label-plein-bleu.svg'
import fortyEightHoursPleinBleu from '../../../assets/48h-plein-bleu.svg'

export const data = [
  {
    icon: handshakePleinBleu,
    title: 'Un expert dédié à votre écoute',
    text: 'Interlocuteur unique et indépendant tout au long du déménagement',
  },
  {
    icon: cartonFragilePleinBleu,
    title: 'Moins cher et garanti',
    text: 'Nos tarifs sont compétitifs et garantis',
  },
  {
    icon: labelPleinBleu,
    title: 'Les meilleurs déménageurs',
    text: 'de notre réseau pour votre déménagement',
  },
  {
    icon: fortyEightHoursPleinBleu,
    title: 'Vos devis sous 48 heures',
    text: 'Comparez les prix très rapidement.',
  },
]
